import "./ContactUsCardLocation.css"

export default function ContactUsCardLocation() {
  return (
    <div className="ContactUsCardLocation">
        1 Forest Avenue Kirwan —­ Corner Ross River Road
    </div>
  )
}
